import { render } from "./App.vue?vue&type=template&id=71ac237e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/_vue_us_stage_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__